module.exports = __webpack_public_path__ + "img/cfb.6b9c2dae.png";